import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Trans, useTranslation } from "react-i18next";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Link from "@material-ui/core/Link";

import grey from "@material-ui/core/colors/grey";

const useStyles = makeStyles(theme => ({
  actionsContainer: {
    padding: theme.spacing(2),
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },

  cancelButton: {
    textTransform: "uppercase",
  },

  iframe: {
    width: "100%",
    height: "99%",
  },

  iframeContainer: {
    padding: theme.spacing(1),
    height: "90%",
    overflowX: "hidden",
    overflowY: "auto",
    borderBottomStyle: "solid",
    borderBottomColor: grey[300],
  },

  paper: {
    width: "90%",
    height: "95%",
  },
}));

const TermsDialog = ({ visible, termsUri, onAccept, onDecline }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog
      onClose={onDecline}
      open={visible}
      aria-labelledby="terms-dialog-title"
      classes={{
        paper: classes.paper,
      }}
    >
      <DialogTitle id="terms-dialog-title">{t("terms_title")}</DialogTitle>
      <DialogContent>
        <div className={classes.iframeContainer}>
          <iframe
            title="Terms"
            src={termsUri + "?cb=" + Date.now()}
            className={classes.iframe}
            tabIndex={-1}
            frameBorder={0}
          />
        </div>
        <Trans>
          If you have issues viewing or navigating these terms, you can{" "}
          <Link href={termsUri} target="_blank">
            open these terms in a new tab
          </Link>{" "}
          to review.
        </Trans>
      </DialogContent>
      <DialogActions>
        <div className={classes.actionsContainer}>
          <Button classes={{ label: classes.cancelButton }} onClick={onDecline}>
            {t("terms_cancel")}
          </Button>
          <Button variant="contained" color="secondary" onClick={onAccept}>
            {t("terms_accept")}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default TermsDialog;
